import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=001960b7&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"
import style0 from "./Employee.vue?vue&type=style&index=0&id=001960b7&prod&scoped=true&lang=css"
import style1 from "./Employee.vue?vue&type=style&index=1&id=001960b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001960b7",
  null
  
)

export default component.exports